// Ejar's own comments on a contract in the Monthly Calculator (owner, 4 Oct 2026: "استورد كل الكومنتات من ايجار
// للكومنتات الحاسبة ... ولو وقفت على الشهر يظهرلى الكومنت بتاع الشهر ده"). The engine keeps them on the contract's
// record (store_sync: {at, by, text, type}); the page shows them read-only beside the staff notes, and each month row
// shows the comments written inside it. Pure: no React.

const day = (at) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(at || ''));
    return m ? `${m[3]}/${m[2]}/${m[1]}` : '';
};

// dd/mm/yyyy -> a number that orders days (yyyymmdd); 0 when unreadable
const dayNumber = (dmy) => {
    const m = /^(\d{1,2})\/(\d{1,2})\/(\d{4})/.exec(String(dmy || '').trim());
    return m ? Number(m[3]) * 10000 + Number(m[2]) * 100 + Number(m[1]) : 0;
};

/** The contract's Ejar comments, newest first: [{key, at, day: 'dd/mm/yyyy', time: 'HH:MM', by, text, type}]. */
export const ejarCommentsOf = (contract) => (Array.isArray(contract?.ejar_comments) ? contract.ejar_comments : [])
    .filter((c) => c && String(c.text || '').trim())
    .map((c, i) => ({
        key: `${c.at || ''}-${i}`,
        at: String(c.at || ''),
        day: day(c.at),
        time: String(c.at || '').slice(11, 16),
        by: String(c.by || '').trim(),
        text: String(c.text).trim(),
        type: String(c.type || ''),
    }))
    .sort((a, b) => (a.at < b.at ? 1 : a.at > b.at ? -1 : 0));

/**
 * The comments written inside each month row (the row's start day up to the next row's start; the last row up to its
 * end): an array per row, oldest first. A comment before the first month goes with the first, one after the last
 * month with the last - nothing is left out.
 */
export const commentsByMonth = (rows, comments) => {
    const list = Array.isArray(rows) ? rows : [];
    const out = list.map(() => []);
    if (!list.length) return out;
    const starts = list.map((r) => dayNumber(r?.start));
    for (const c of [...(comments || [])].sort((a, b) => (a.at < b.at ? -1 : a.at > b.at ? 1 : 0))) {
        const d = dayNumber(c.day);
        if (!d) continue;
        let idx = 0;
        for (let i = 0; i < list.length; i += 1) if (starts[i] && starts[i] <= d) idx = i;
        out[idx].push(c);
    }
    return out;
};

/** A month's comments as one tooltip text. */
export const commentsTooltip = (list) => (list || [])
    .map((c) => `${c.day}${c.by ? ` · ${c.by}` : ''}\n${c.text}`).join('\n\n');
